/**
 * Format a Date object as YYYY-MM-DD
 */
function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Get today's date as YYYY-MM-DD
 */
export function today(): string {
  return formatDate(new Date());
}

/**
 * Get date N hours ago as YYYY-MM-DD
 */
export function hoursAgo(hours: number): string {
  const date = new Date();
  date.setHours(date.getHours() - hours);
  return formatDate(date);
}

/**
 * Get date N days ago as YYYY-MM-DD
 */
export function daysAgo(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return formatDate(date);
}

/**
 * Get date N weeks ago as YYYY-MM-DD
 */
export function weeksAgo(weeks: number): string {
  const date = new Date();
  date.setDate(date.getDate() - weeks * 7);
  return formatDate(date);
}

/**
 * Get date N months ago as YYYY-MM-DD (first day of that month)
 */
export function monthsAgo(months: number): string {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  date.setDate(1); // First day of the month
  return formatDate(date);
}

/**
 * Get date N quarters ago as YYYY-MM-DD (first day of that quarter)
 */
export function quartersAgo(quarters: number): string {
  const date = new Date();
  date.setMonth(date.getMonth() - quarters * 3);
  const quarterStartMonth = Math.floor(date.getMonth() / 3) * 3;
  date.setMonth(quarterStartMonth);
  date.setDate(1);
  return formatDate(date);
}

/**
 * Get date N years ago as YYYY-MM-DD (first day of that year)
 */
export function yearsAgo(years: number): string {
  const date = new Date();
  date.setFullYear(date.getFullYear() - years);
  date.setMonth(0); // January
  date.setDate(1); // First day of the year
  return formatDate(date);
}

// Re-export consolidated date utilities
export { formatDateToISO } from './format-to-iso';
export { formatISODateToDisplay, formatNumericDate } from './format-to-display';
export { normalizeDate } from './normalize-date';

export default null; // silence a false warning
